import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const excludedUrls = [
    `${environment.apiUrl}/auth/login`,
    `${environment.apiUrl}/health`,
  ];
  const isExcluded = excludedUrls.some((excludedUrl) => request.url.startsWith(excludedUrl));
  const token = localStorage.getItem('token')
    ?? localStorage.getItem('nrpc_access_token')
    ?? sessionStorage.getItem('token')
    ?? sessionStorage.getItem('nrpc_access_token');

  if (isExcluded || !token || request.headers.has('Authorization')) {
    return next(request);
  }

  return next(request.clone({
    setHeaders: { 
      Authorization: `Bearer ${token}`,
    },
  }));
};
